import { Button, Modal } from '@figma/fpl-components';
import { useTranslation } from 'react-i18next';
import { color } from '@/colors';
import { FF_FPL_MIGRATION } from '@/consts/featureFlags';
import { ZIndex } from '@/consts/z-indexes.consts';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { I18N_KEYS } from '@/language/keys';
import { useGlobalStore } from '@/state/global.state';
import { Typography } from '@/UI/AppTypography/AppTypography';
import { themeColor } from '@/UI/themeColors';
import { ButtonContained } from '../Buttons/AppButton';
import { InfoIcon } from '../Icons';
import { FlexCenHorVer } from '../styles';

interface ReloadAlertStandaloneProps {
  message: string;
  ctaText: string;
  onRefresh: () => void;
}

export const ReloadAlertStandalone = ({ message, ctaText, onRefresh }: ReloadAlertStandaloneProps) => {
  const isFpl = useFeatureFlag(FF_FPL_MIGRATION).value === true;

  if (isFpl) {
    return (
      <Modal.Root open onClose={() => {}} preventUserClose width="md" data-testid="fpl-reload-modal">
        <Modal.Contents>
          <Modal.Header>
            <Modal.Title>{message}</Modal.Title>
            <Modal.ActionStrip>
              <Button variant="primary" onClick={onRefresh}>
                {ctaText}
              </Button>
            </Modal.ActionStrip>
          </Modal.Header>
        </Modal.Contents>
      </Modal.Root>
    );
  }

  return (
    <FlexCenHorVer
      sx={{
        position: 'fixed',
        inset: 0,
        backgroundColor: color.Black84_T,
        zIndex: ZIndex.Overlays.CRITICAL_SYSTEM_ALERT,
      }}
    >
      <FlexCenHorVer
        sx={{
          height: 40,
          backgroundColor: themeColor.white64,
          borderRadius: 1,
          pl: 1.5,
          py: 1.75,
          pr: 1,
        }}
      >
        <InfoIcon style={{ width: 20, height: 20, marginRight: '8px' }} color={color.Black100} />
        <Typography variant="body-sm-rg" color={color.Black100} mr={2}>
          {message}
        </Typography>
        <ButtonContained mode="text" onClick={onRefresh} sx={{ fontSize: '0.75rem', color: color.Black100 }}>
          {ctaText}
        </ButtonContained>
      </FlexCenHorVer>
    </FlexCenHorVer>
  );
};

export const ReloadAlert = () => {
  const isShowRefreshAlert = useGlobalStore((state) => state.isShowRefreshAlert);
  const { t } = useTranslation();
  if (!isShowRefreshAlert) return null;

  return (
    <ReloadAlertStandalone
      message={t(I18N_KEYS.GENERAL.RELOAD_ALERT_TITLE)}
      ctaText={t(I18N_KEYS.GENERAL.RELOAD_ALERT_CTA)}
      onRefresh={() => window.location.reload()}
    />
  );
};
